module.exports = __webpack_public_path__ + "static/media/ankur.082de820.jpg";